import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelSelect as _vModelSelect, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/imgcaptions/piceBox.png'
import _imports_1 from '@/assets/imgcaptions/icon_tianjiasel.png'


const _hoisted_1 = { class: "versionPopupList" }
const _hoisted_2 = { class: "versionList" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "versionOneNum" }
const _hoisted_5 = ["onMousemove"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "versionBtn" }
const _hoisted_10 = {
  key: 0,
  class: "newVersion"
}
const _hoisted_11 = { class: "newVersionTitle" }
const _hoisted_12 = { class: "newVersionList" }
const _hoisted_13 = { class: "versionSel" }
const _hoisted_14 = { class: "versionNameBox" }
const _hoisted_15 = { class: "versionNameInput" }
const _hoisted_16 = { class: "versionNameBox" }
const _hoisted_17 = { class: "versionNameInput" }
const _hoisted_18 = { class: "newVersionBtn" }
const _hoisted_19 = {
  key: 0,
  class: "stripBoxmask"
}
const _hoisted_20 = { class: "stripdelBox" }

import { ref, onMounted ,watch} from 'vue'
// 时间处理方法
import { timeInfo, timeInfominute, timedata } from '@/components/public-method/time-method';
// 引入删除提示
import delbox from "@/components/common/del.vue";
// 引入接口
import newCaptionApi from "@/api/newCaption/index.ts";
import {
    Close,
} from "@element-plus/icons-vue";
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'versionList',
  props: {
        versionBoxData:Array,
        id:Number,
        subtitle:String,
    },
  emits: ['selvs','reVersionList','closeThis'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const props = __props
const emit = __emit
const   opendelShow=ref(false)
const delText=ref('删除该版本，且永久不可恢复，确认删除？')
const recognition=()=>{
    let list=[]
    addVersList.value.forEach(it=>{
        list.push(it.textId)
    })
    newCaptionApi.delrelease(list).then(res=>{
        console.log(res)
        emit('reVersionList')
        addVersList.value=[]
        emit('closeThis')
    })
}
// 
const overIndex=ref(-1)
const listBoxOver=(e:any,index:number)=>{
    
    let len=e.currentTarget.offsetWidth
    if(len>80){
        overIndex.value=index
    }
    else{
        overIndex.value=-1
   
    }
}
const covers=ref(false)
const versionUpShow = ref(false)
const version=ref('')
// 选择版本
const selIndex=ref(-1)
const releaseNote=ref('')
onMounted(()=>{
    // console.log('-----++---'+props)
    // console.log(props)
    // console.log(props.versionBoxData)
    selIndex.value=props.versionBoxData.findIndex(item=>item.textId==props.id)
    addVersList.value=[]
    // console.log('===='+selIndex.value)
})
watch(() => props.versionBoxData, (n, o) =>{
       
    console.log('--------'+n)
    selIndex.value=props.versionBoxData.findIndex(item=>item.textId==props.id)
    console.log(props.versionBoxData)
    console.log(props.id)
    console.log(selIndex.value)
})
watch(() => props.id, (n, o) =>{
       
       console.log('--------'+n)
       selIndex.value=props.versionBoxData.findIndex(item=>item.textId==n)
   })
const selStyle={
    "background":'rgba(30, 113, 224, .6)'
}
const selVersion=(index:number,textId:string)=>{
    selIndex.value=index
    // console.log(textId)
    emit('selvs',textId)
}

// 打开发布弹窗
const toRelease=()=>{
    versionUpShow.value=true
}
// 关闭发布弹窗
const closeRelease=()=>{
    versionUpShow.value=false
}
// 发布版本
const upRelease=()=>{
    versionUpShow.value=false
    newCaptionApi.release( covers.value, props.id,releaseNote.value,version.value).then((res)=>{
        console.log(res)
        if(res.code==200){
            console.log('发布成功')
            emit('reVersionList')
            
        }
    })
}

// 浮动展示按钮
// const overIndex=ref(-1)
// const overThis=(index:number)=>{
//     overIndex.value=index
// }
// 添加版本
const addVersList=ref([])
const addVers=(item:any)=>{
    const obj={
        textId:item.textId
    }
    const onHave=addVersList.value.findIndex(it=>it.textId==item.textId) //是否还有该版本
    console.log(addVersList.value)
    console.log(onHave)
    if(onHave>=0){
        console.log('删除')
        addVersList.value.splice(onHave,1)

    }else{
        addVersList.value.push(obj)
        // if(addVersList.value.length<2){
        //     addVersList.value.push(obj)
        // }
    }
    console.log(addVersList.value)
}
// 提交版本对比
const contrastStyle={
    'background': 'rgba(32, 124, 246, 0.90)'
}
const contrast=()=>{
    console.log(addVersList.value)
    console.log('跳转版本对比页面')
    
    if(addVersList.value.length==2){
        const ids=addVersList.value[0].textId+','+addVersList.value[1].textId
        console.log(props.subtitle)
        // router.push({ path: '/index/aiApply/contrast' })
        router.push({ path: '/index/aiApply/contrast', query: { id: ids,oldId:props.subtitle } })
        // 
        // newCaptionApi.getEditCaption(ids).then(res=>{
        //     console.log(res)

        // })
    }
}
// 删除版本
const delcontrast=()=>{
    if(props.versionBoxData.length==1||addVersList.value.length==0){
        return
    }
    opendelShow.value=true
}
// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "versionPopupBox",
    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.versionBoxData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "versionOne",
            key: index,
            onClick: _withModifiers(($event: any) => (selVersion(index,item.textId)), ["stop"]),
            style: _normalizeStyle((index==selIndex.value||addVersList.value.filter(it=>it.textId==item.textId).length>0)?selStyle:'')
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass([overIndex.value==index?'versionOneNumInnerRun':'', "versionOneNumInner"]),
                onMousemove: ($event: any) => (listBoxOver($event,index)),
                onMouseout: _cache[0] || (_cache[0] = ($event: any) => (overIndex.value=-1))
              }, _toDisplayString(item.version), 43, _hoisted_5)
            ]),
            _createElementVNode("div", {
              class: "versionOneTime",
              onClick: _withModifiers(($event: any) => (addVers(item)), ["stop"])
            }, [
              _createElementVNode("span", null, _toDisplayString(_unref(timedata)(item.createTime)), 1),
              _withDirectives(_createElementVNode("img", {
                src: _imports_0,
                alt: "",
                onClick: _withModifiers(($event: any) => (addVers(item)), ["stop"])
              }, null, 8, _hoisted_7), [
                [_vShow,  (addVersList.value.filter(it=>it.textId==item.textId).length==0)]
              ]),
              _withDirectives(_createElementVNode("img", {
                src: _imports_1,
                alt: "",
                onClick: _withModifiers(($event: any) => (addVers(item)), ["stop"])
              }, null, 8, _hoisted_8), [
                [_vShow,   addVersList.value.filter(it=>it.textId==item.textId).length>0]
              ])
            ], 8, _hoisted_6)
          ], 12, _hoisted_3))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", {
          class: "contrast",
          onClick: _withModifiers(contrast, ["stop"]),
          style: _normalizeStyle(addVersList.value.length==2?contrastStyle:'')
        }, "版本对比", 4),
        _createElementVNode("span", {
          class: "versionUp",
          onClick: _withModifiers(delcontrast, ["stop"])
        }, "删除"),
        _createElementVNode("span", {
          class: "versionclose",
          onClick: _withModifiers(closeBox, ["stop"])
        }, "关闭")
      ])
    ]),
    (versionUpShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "发布", -1)),
            _createElementVNode("span", {
              class: "closeBtn",
              onClick: _withModifiers(closeRelease, ["stop"])
            }, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Close))
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("select", {
                name: "",
                id: "",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((covers).value = $event)),
                class: "selectVers"
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("option", { value: "false" }, "发布为新版本", -1),
                _createElementVNode("option", { value: "true" }, "替换当前版本", -1)
              ]), 512), [
                [_vModelSelect, covers.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "versionName" }, "版本名称", -1)),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "请输入版本名称",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((version).value = $event))
                }, null, 512), [
                  [_vModelText, version.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "versionName" }, "版本说明", -1)),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("textarea", {
                  placeholder: "请输入版本名称",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((releaseNote).value = $event))
                }, null, 512), [
                  [_vModelText, releaseNote.value]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", {
              class: "btnNo",
              onClick: _withModifiers(closeRelease, ["stop"])
            }, "取消"),
            _createElementVNode("span", {
              class: "btnOk",
              onClick: _withModifiers(upRelease, ["stop"])
            }, "确定")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (opendelShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(delbox, {
                text: delText.value,
                onCloseThis: _cache[4] || (_cache[4] = ($event: any) => (opendelShow.value = false)),
                onRecognition: recognition
              }, null, 8, ["text"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})